module.exports = __webpack_public_path__ + "static/media/emojione_flag-for-spain.261967ce.svg";